import {
  ADD_PRODUCT,
  UPDATE_PRODUCT,
  GET_PRODUCT_REQ,
  GET_ALL_PRODUCT,
  GET_ONE_PRODUCT,
  GET_ALL_WHO_STRENGTH_UNIT,
  GET_ALL_WHOC3_UNIT,
  GET_ALL_PRODUCT_LIST,
  OLD_ADMINPRODUCT_VALUE
} from '../types'

const INITIAL_STATE = {
  allProduct: [],
  addproduct: [],
  updateProduct: [],
  oneProduct: [],
  allStrength: [],
  getAllWhoC3Units: [],
  allProductList: [],
  page_count: null,
  oldProductValue:{}
}

const productReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_PRODUCT_REQ:
      return {
        ...state,
      }
    case GET_ALL_PRODUCT:
      return {
        ...state,
        allProduct: payload.data,
      }

    case GET_ALL_PRODUCT_LIST:
      return {
        ...state,
        allProductList: payload.data,
        page_count: payload.total_records,
      }
    case ADD_PRODUCT:
      return {
        ...state,
        addproduct: payload.data,
      }
    case UPDATE_PRODUCT:
      return {
        ...state,
        updateProduct: payload.productId,
      }
    case OLD_ADMINPRODUCT_VALUE:
      return {
        ...state,
        oldProductValue:payload,
      }
    case GET_ONE_PRODUCT:
      return {
        ...state,
        oneProduct: payload.data,
      }
    case GET_ALL_WHO_STRENGTH_UNIT:
      return {
        ...state,
        allStrength: payload.data,
      }
    case GET_ALL_WHOC3_UNIT:
      return {
        ...state,
        getAllWhoC3Units: payload.data,
      }
    default:
      return state
  }
}

export default productReducer
